
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-avatar',
    imports: [
    MatIconModule,
    MatTooltipModule
],
    templateUrl: './avatar.component.html',
    styleUrl: './avatar.component.scss'
})
export class AvatarComponent {

  @Input() name = '';
  @Input() isProfileEdit = false;
  @Input() imageUrl: string | null = null; // To display uploaded image
  @Output() imageSelected = new EventEmitter<File>();
  @Output() imageDeleted = new EventEmitter<void>();

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  get firstLetter(): string {
    if (!this.name) return '';
    return this.name.trim() ? this.name.charAt(0).toUpperCase() : '';
  }

  openFileDialog() {
    this.fileInput.nativeElement.click();
  }

  onFileChange(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.imageSelected.emit(file);
    }
  }

  onDelete() {
    this.imageDeleted.emit();
  }

}
